<div class="main-content">
    <div class="position-relative card-body main-card card" style="box-shadow: none">
        <form [formGroup]="bulkAddForm" (ngSubmit)="onSubmit()">
            <div class="droparea d-flex flex-column align-items-center p-4">
                <svg width="93" height="82" viewBox="0 0 93 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.6667 13.3333H27.0516C28.0571 13.3333 28.5603 13.3333 29.0334 13.4469C29.4529 13.5476 29.8556 13.7142 30.2234 13.9396C30.6382 14.1937 30.9943 14.5499 31.7049 15.2604L44.2961 27.8517C45.0071 28.5627 45.3607 28.9162 45.6149 29.3311C45.8403 29.6989 46.0091 30.101 46.1098 30.5205C46.2222 30.9888 46.2222 31.4861 46.2222 32.4712V62.6667M25.6667 13.3333H7.57617C5.27373 13.3333 4.12366 13.3333 3.24425 13.7814C2.47069 14.1756 1.84223 14.804 1.44808 15.5776C1 16.457 1 17.6091 1 19.9115V68.4226C1 70.7251 1 71.8747 1.44808 72.7541C1.84223 73.5277 2.47069 74.1582 3.24425 74.5524C4.12282 75 5.27153 75 7.56954 75L39.6488 75C41.9467 75 43.0997 75 43.9783 74.5524C44.7519 74.1582 45.3784 73.5286 45.7726 72.7551C46.2207 71.8757 46.2222 70.7241 46.2222 68.4216V62.6667M25.6667 13.3333V27.3111C25.6667 29.6135 25.6667 30.764 26.1148 31.6434C26.5089 32.4169 27.1374 33.0471 27.9109 33.4412C28.7895 33.8889 29.9382 33.8889 32.2361 33.8889H46.2206M29.7778 13.3337V7.57818C29.7778 5.27574 29.7778 4.12366 30.2259 3.24425C30.62 2.47069 31.2485 1.84223 32.022 1.44808C32.9014 1 34.0515 1 36.354 1H54.4444M54.4444 1H55.8294C56.8349 1 57.338 1 57.8112 1.11359C58.2307 1.2143 58.6334 1.38082 59.0012 1.60623C59.4159 1.86038 59.7721 2.21654 60.4826 2.92708L73.0739 15.5184C73.7849 16.2294 74.1384 16.5829 74.3927 16.9978C74.6181 17.3656 74.7869 17.7677 74.8876 18.1872C75 18.6555 75 19.1527 75 20.1379V56.0883C75 58.3907 74.9984 59.5423 74.5503 60.4218C74.1562 61.1953 73.5321 61.8249 72.7585 62.219C71.8799 62.6667 70.7285 62.6667 68.4306 62.6667H46.2222M54.4444 1V14.9778C54.4444 17.2802 54.4444 18.4306 54.8925 19.31C55.2867 20.0836 55.9151 20.7138 56.6887 21.1079C57.5672 21.5556 58.7159 21.5556 61.0139 21.5556H74.9984" stroke="#D7D7D7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="74.5" cy="63.5" r="18.5" fill="white"/>
                    <circle cx="74.5" cy="63.5" r="14.5" fill="white" stroke="#18A0F8"/>
                    <path d="M75 69V59M75 59L71 63M75 59L79 63" stroke="#18A0F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

                <div class="bulk-info-title mt-4 px-sm-3 text-center">
                    Click <span>here</span> or drag and drop to add files
                </div>

                <div class="bulk-info-message px-sm-2 px-md-4">
                    {{ 'bulk-add-form.infoMessage' | translate }}
                </div>
            </div>

            <div>
                <input
                    formControlName="file" 
                    id="file" 
                    type="file"
                    accept=".csv, text/csv"
                    [class.hidden]="!showHeaderComparison"
                    (input)="changeName($event)"
                    (change)="fileChange($event)"
                />
            </div>
        </form>
    </div>

    <div class="p-4 pt-0" *ngIf="showHeaderComparison">
        <input 
            placeholder="{{ 'bulk-add-form.chooseFilePlaceholder' | translate }}"
            [(ngModel)]="chosenFile"
            class="file-label mb-3"
            disabled="true"
        >

        <div class="position-relative form-group mb-3" style="width:90%;" *ngIf="(campaigns$ | async).length > 1">
            <label class="campaign-style">
              All contacts will be added to the following campaign:
            </label>

            <app-campaign-dropdown
                [campaignsBasicInfo]="campaigns$ | async"
                [multiSelect]="false"
                [selectedCampaigns]="selectedCampaign"
                (onSelect)="changeContactCampaign($event)">
            </app-campaign-dropdown>
        </div> 

        <table class="table form-group mat-mdc-table mdc-data-table_table comparison-headers w-100">
            <thead>
                <tr class="mat-mdc-header-row mdc-data-table__header-row">
                    <th class="mat-mdc-header-cell mdc-data-table__header-cell"
                        *ngFor="let column of headers"
                        scope="col"
                    >
                        {{ convertCamelCase(column) }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr class="mat-mdc-row mdc-data-table__row">
                    <td
                        *ngFor="let column of headers; let i = index"
                        class="mat-mdc-cell mdc-data-table__cell"
                        [style.overflow]="'visible'"
                    >
                        <p-dropdown class="short"
                            [options]="csvHeaders"
                            placeholder="Select column"
                            [showClear]="true"
                            (onChange)="onChangeSelects($event, i)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>

        <button class="mt-2 btn btn-primary center" (click)="validateNonSelectedFields()">
            Show Data
        </button>
    </div>
</div>
